import React from 'react';
import { DeviceType, useDeviceType } from '@hotelplan/libs.context.device-type';
import { ESearchType } from 'fdr/components/candidate/fdr-search-control/destination/fdr-destination-field.types';
import { FdrSearchForm } from 'fdr/components/local/fdr-search-form/fdr-search-form';
import {
  EThemeFormPageType,
  IFdrThemeProps,
} from 'fdr/components/local/fdr-theme/fdr-theme.types';

const themeTypeToSearchType = {
  [EThemeFormPageType.THEME]: ESearchType.THEME,
  [EThemeFormPageType.THEME_OVERVIEW]: ESearchType.THEME_OVERVIEW,
};

const FdrThemeSearchForm: React.FC<IFdrThemeProps> = ({
  id,
  handleCancel,
  postSubmit,
  pageType,
}) => {
  const { mobile } = useDeviceType();

  const deviceType = mobile ? DeviceType.Mobile : DeviceType.Desktop;
  const searchType = themeTypeToSearchType[pageType];

  const extraVars =
    searchType === ESearchType.THEME_OVERVIEW ? { deviceType } : {};

  return (
    <FdrSearchForm
      id={id}
      extraVars={extraVars}
      postSubmit={postSubmit}
      searchType={searchType}
      handleCancel={handleCancel}
    />
  );
};

export default FdrThemeSearchForm;
